import type { FC } from 'react';
import { CursorClickIcon } from '@heroicons/react/outline';
import type { PlainAction } from '@root/@types/types';
import clsx from 'clsx';
import pluralize from 'pluralize';

import { ActionButton } from '../../ActionButton';

interface TableEmptyStateProps {
  action?: PlainAction;
  entityName: string;
}

export const TableEmptyState: FC<TableEmptyStateProps> = ({ action, entityName }) => {
  return (
    <div className="absolute top-1/2 left-1/2 flex h-full w-full -translate-x-1/2 -translate-y-3/5 items-center justify-center">
      <div className={clsx('flex flex-col items-center justify-start gap-6')}>
        <CursorClickIcon height={48} className="text-gray-400" />
        <div className="flex flex-col items-center justify-start gap-2">
          <div className="self-stretch text-center text-xl leading-[48px] font-bold text-gray-700">
            No {pluralize(entityName)} yet
          </div>
          <div className="self-stretch text-center text-base leading-normal font-normal text-gray-500">
            Create a new {entityName} to get started and it will show up here
          </div>
        </div>
        {action && <ActionButton action={action} />}
      </div>
    </div>
  );
};
